import { createContext, useContext } from "react"

import { ProductInformation } from "shared/types/__generated__/graphql"

export interface ProductConfigurationAttributesContextValue {
  productInformation: ProductInformation | null | undefined
  isLoading?: boolean
  copyToClipboard: () => void
}

export const ProductConfigurationAttributesContext =
  createContext<ProductConfigurationAttributesContextValue | null>(null)

export function useProductConfigurationAttributesContext(): ProductConfigurationAttributesContextValue {
  const ctx = useContext(ProductConfigurationAttributesContext)
  if (!ctx) {
    throw new Error(
      "useProductConfigurationAttributesContext must be used within ProductConfigurationAttributes.Root"
    )
  }
  return ctx
}
